module.exports = __webpack_public_path__ + "static/img/icon_FAIL.e910d7ee.png";